import cn from 'classnames'
import styles from './card.module.scss'

/**
 * @param {{
 *   title?: string,
 *   eyebrow?: string,
 *   lift?: boolean,
 *   action?: React.ReactNode,
 *   children: React.ReactNode,
 *   className?: string
 * }} props
 */
export function Card({title, eyebrow, lift = false, action, children, className}) {
    return (
        <section className={cn(styles.card, {[styles.lift]: lift}, className)}>
            {(title || eyebrow || action) && (
                <header className={styles.header}>
                    <div className={styles.headerText}>
                        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
                        {title && <h2 className={styles.title}>{title}</h2>}
                    </div>
                    {action && <div className={styles.action}>{action}</div>}
                </header>
            )}
            <div className={styles.body}>{children}</div>
        </section>
    )
}
